import { useEffect, useState } from "react";
import { Button, Card, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import CardItem from "./CardItem";
import { Translate } from "../../../Enums/Tranlate";
import Loader from "../../../common/Loader";
import NoData from "../../../common/NoData";
import Pagination from "../../../common/Pagination/Pagination";
import LeaderShipService from "../../../../services/LeaderShipService";

const Leadership = () => {
	const [admins, setAdmins] = useState(null);
	const [hasData, setHasData] = useState(null);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const Service = new LeaderShipService();
	const lang = useSelector((state) => state.auth?.lang);
	const location = useLocation();

	return (
		<div className="admin">
			<Card className="mb-3">
				<div className="d-flex justify-content-between align-items-center p-3">
					<div>
						<span
							style={{
								fontWeight: "600",
								textTransform: "capitalize",
								color: "#000",
							}}>
							{Translate[lang].leadership}
						</span>
					</div>
					<div className="add-admin">
						<Button
							variant="primary"
							className="me-2 h-75"
							onClick={() => {
								navigate("/leadership/add-leadership");
							}}>
							<i
								className={`la la-plus ${lang === "en" ? "mr-2" : "ml-2"}`}></i>
							{Translate[lang]?.add} {Translate[lang].leadership}
						</Button>
					</div>
				</div>
			</Card>

			<Card>
				<Card.Body
					className={`${hasData === 0 ? "text-center" : "table-style"}`}>
					{loading && (
						<div style={{ height: "300px" }}>
							<Loader />
						</div>
					)}
					{hasData === 1 && !loading && (
						<Table responsive>
							<thead>
								<tr>
									<th>
										<strong>{Translate[lang]?.name}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.job}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.image}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.action}</strong>
									</th>
								</tr>
							</thead>
							<tbody>
								{admins?.length > 0 &&
									admins?.map((item, index) => {
										return (
											<CardItem
												key={index}
												index={index}
												item={item}
												Service={Service}
												setShouldUpdate={setShouldUpdate}
											/>
										);
									})}
							</tbody>
						</Table>
					)}
					{hasData === 0 && <NoData />}
					<Pagination
						setData={setAdmins}
						service={Service}
						shouldUpdate={shouldUpdate}
						setHasData={setHasData}
						setLoading={setLoading}
					/>
				</Card.Body>
			</Card>
		</div>
	);
};
export default Leadership;
